
  import { useEffect } from 'react';
  import '../../../App.scss';
  import './Working.scss';
  import HeaderBar from '../headerBar';
  import ProcessSection from '../ProcessSection';
  import { processPhases } from '../../../data/processPhases';

  function Working() {
    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);

    return (
      <>
        <HeaderBar
          Descr="HOW I WORK"
          Location="FROM AMBIGUITY TO ACTION"
          time=""
        />

        <section className="working-intro">
          <div className="working-intro__inner">
            <h2>My Approach</h2>
            <p>
              I help organizations move from ambiguity to aligned action—blending
              service design, product strategy, and delivery thinking.
            </p>
          </div>
        </section>

        {processPhases.map((phase, index) => (
          <ProcessSection key={phase.id} {...phase} index={index} />
        ))}

        <section className="working-cta">
          <h2>Let&apos;s build clarity together</h2>
          <p>
            I work across service design, product strategy, and AI-enabled
            transformation.
          </p>
          <a href="mailto:mike@mcameron.io" aria-label="Email Mike Cameron">mike@mcameron.io</a>
        </section>
      </>
    );
  }

  export default Working;
  